import { s3base } from "api";
import Image from "components/Image/Image";
import BootstrapModal from "components/PopUps/BootstrapModal";
import ModalSkeleton from "components/PopUps/ModalSkeleton";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Item = ({ title, thumbnail, vidLink, id, description }) => {
  const [modelStatus, setModelStatus] = useState(false);
  const navigate = useNavigate();

  const modelHandler = () => {
    if (!vidLink) {
      setModelStatus((prevState) => !prevState);
      return;
    }
    navigate("/admin/video/" + id);
  };

  let vidPopup;
  if (!vidLink) {
    vidPopup = (
      <ModalSkeleton
        status={modelStatus}
        toggle={modelHandler}
        handleClick={() => {
          navigate("/admin/plans");
        }}
        btnText="Buy Plan"
        message="Please subscribe to our gold plan to see Secret Strategy Videos"
        isSmall={true}
      />
    );
  }

  return (
    <div className="strategy-video-card">
      <div className="strategy-video-wrapper" onClick={modelHandler}>
        <Image path={s3base + thumbnail} alt="" classes="" />
      </div>
      <div className="strategy-video-content">
        <h2 className="title">{title}</h2>
        {/* <p className="sub-title">{description}</p> */}
        {/* <p className="sub-title">How I Scored 90 for the 6th time</p> */}
        <p className="timing">12 Mins</p>
      </div>
      {vidPopup}
    </div>
  );
};

export default Item;
